// extracted by mini-css-extract-plugin
export default {"wrapper":"AcademicTrack_wrapper__Wo8On","buttonWrap":"AcademicTrack_buttonWrap__yD1sg","cancelBtn":"AcademicTrack_cancelBtn__004nQ","titleWrap":"AcademicTrack_titleWrap__DNmyB"};